import { render, staticRenderFns } from "./order-delivery-estimation.vue?vue&type=template&id=4b994f40"
import script from "./order-delivery-estimation.vue?vue&type=script&lang=js"
export * from "./order-delivery-estimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports